import React, {Component} from "react";
import {ALL_METRICS, PROPERTIES_FOR_METRIC} from "../dashboard/metrics";

export class MetricsSelect extends Component {
    render () {
        return (<select name={this.props.name}
                        onChange={this.props.onChange}
                        value={this.props.value}
                        disabled={this.props.disabled}
                        className={"form-select"}>
            <option key='empty-option' value=''>-----</option>
            {ALL_METRICS.map((metricName) =>
                <option key={metricName} value={metricName}>{PROPERTIES_FOR_METRIC[metricName]["Spanish"]}</option>
            )}
        </select>);
    }
}
